import React, { useState } from 'react';
import { ThumbsUpIcon, MessageCircleIcon } from 'lucide-react';
interface Comment {
  id: number;
  name: string;
  image: string;
  text: string;
  likes: number;
  time: string;
  replies?: number;
  verified?: boolean;
}
export function SocialProof() {
  const [showAllComments, setShowAllComments] = useState(false);
  const comments: Comment[] = [{
    id: 1,
    name: 'Margareta Svensson',
    image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'Jag har använt Brainy i 2 månader nu och märker verkligen skillnad i min koncentrationsförmåga. Jag behöver inte längre skriva listor på allt för att komma ihåg saker. Min dotter blev faktiskt förvånad när jag kom ihåg alla detaljer från vårt senaste samtal! 😊',
    likes: 34,
    time: '3 timmar sedan',
    replies: 5,
    verified: true
  }, {
    id: 2,
    name: 'Anders Lindqvist',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'Var skeptisk i början men min fru övertalade mig att prova. Efter ca 3 veckor märkte jag att jag inte längre behövde läsa samma stycke i tidningen flera gånger. Hjärndimman är borta. Rekommenderar starkt!',
    likes: 21,
    time: '5 timmar sedan',
    verified: true
  }, {
    id: 3,
    name: 'Karin Bergström',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'Jobbar som lärare och har alltid många bollar i luften. Började med Brainy för 6 veckor sedan och känner mig mycket mer skärpt på eftermiddagarna nu. Tidigare var jag helt slut i huvudet efter en dag med eleverna, nu kan jag faktiskt planera lektioner på kvällen utan att känna mig helt utmattad mentalt.',
    likes: 47,
    time: '1 dag sedan',
    replies: 8,
    verified: true
  }, {
    id: 4,
    name: 'Göran Pettersson',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'Min fru har märkt skillnad på mig! Jag glömmer inte längre vad hon sagt till mig för fem minuter sedan 😂 Ärligt talat, det är skönt att slippa den där känslan av att alltid vara lite bortkommen. Tar det varje morgon med frukosten.',
    likes: 18,
    time: '2 dagar sedan',
    verified: true
  }, {
    id: 5,
    name: 'Elisabet Holm',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'Har provat många kosttillskott genom åren men detta är det första som faktiskt gett märkbar effekt. Det är ingen mirakelkur, men jag känner mig definitivt mer mentalt närvarande. Kommer fortsätta använda Brainy!',
    likes: 29,
    time: '3 dagar sedan',
    replies: 2,
    verified: true
  }, {
    id: 6,
    name: 'Sven Andersson',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'WOW! Brainy har förändrat mitt liv totalt! Efter bara 1 vecka känner jag mig 20 år yngre mentalt! Kan inte tro att jag väntade så länge med att prova detta. ALLA borde använda Brainy!!! 🔥🔥🔥',
    likes: 156,
    time: '4 timmar sedan',
    replies: 12
  }, {
    id: 7,
    name: 'Lena Johansson',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=120&q=80',
    text: 'Min läkare blev förvånad över mina testresultat efter att jag använt Brainy i 3 månader! Han frågade vad jag gjort annorlunda och kunde knappt tro att det bara var ett kosttillskott! Kommer ALDRIG sluta med Brainy!',
    likes: 89,
    time: '1 dag sedan',
    replies: 7
  }];
  const visibleComments = showAllComments ? comments : comments.slice(0, 5);
  return <div className="mt-8 border border-gray-300 rounded-lg bg-gray-50" data-id="element-380">
      <div className="bg-[#f0f2f5] border-b border-gray-300 p-3 rounded-t-lg" data-id="element-381">
        <h4 className="font-semibold text-lg" data-id="element-382">Kommentarer</h4>
      </div>
      <div className="p-2 sm:p-4" data-id="element-383">
        {visibleComments.map(comment => <div key={comment.id} className="border-b border-gray-200 py-4 last:border-0" data-id="element-384">
            <div className="flex items-start" data-id="element-385">
              <img src={comment.image} alt={comment.name} className="w-10 h-10 rounded-full mr-3" data-id="element-386" />
              <div className="flex-1" data-id="element-387">
                <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-388">
                  <div className="flex items-center" data-id="element-389">
                    <h5 className="font-semibold" data-id="element-390">{comment.name}</h5>
                    {comment.verified && <span className="ml-2 bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full" data-id="element-391">
                        Verifierad köpare ✓
                      </span>}
                  </div>
                  <p className="text-base" data-id="element-392">{comment.text}</p>
                </div>
                <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-393">
                  <button className="font-medium hover:underline mr-4" data-id="element-394">
                    Gilla
                  </button>
                  <button className="font-medium hover:underline mr-4" data-id="element-395">
                    Svara
                  </button>
                  <span data-id="element-396">{comment.time}</span>
                </div>
                <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-397">
                  <div className="flex items-center mr-4" data-id="element-398">
                    <div className="bg-blue-500 text-white rounded-full w-4 h-4 flex items-center justify-center mr-1" data-id="element-399">
                      <ThumbsUpIcon size={10} data-id="element-400" />
                    </div>
                    <span data-id="element-401">{comment.likes}</span>
                  </div>
                  {comment.replies && <div className="flex items-center" data-id="element-402">
                      <MessageCircleIcon size={14} className="mr-1" data-id="element-403" />
                      <span data-id="element-404">{comment.replies} svar</span>
                    </div>}
                </div>
              </div>
            </div>
          </div>)}
        {!showAllComments && <div className="text-center mt-4" data-id="element-405">
            <button onClick={() => setShowAllComments(true)} className="text-blue-600 font-medium hover:underline" data-id="element-406">
              Visa 142 fler kommentarer...
            </button>
          </div>}
      </div>
      <div className="p-3 border-t border-gray-300 bg-white rounded-b-lg" data-id="element-407">
        <div className="flex items-center" data-id="element-408">
          <div className="w-8 h-8 rounded-full bg-gray-200 mr-2" data-id="element-409"></div>
          <div className="flex-1 bg-gray-100 rounded-full px-4 py-2 text-gray-500" data-id="element-410">
            Skriv en kommentar...
          </div>
        </div>
      </div>
    </div>;
}